<app-reports-toolbar></app-reports-toolbar>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div class="container-fluid">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="px-3">
    <!--  -->
    <div class="row">

      <div class="me">



        <div id="id1">
          NAMC/PDC
        </div>
        <div>
          <mat-form-field appearance="outline" class="fixed-select-ord">
            <mat-select [(ngModel)]="selectedOrderPlant" [multiple]="true" [panelWidth]="null" [ngModelOptions]="{standalone: true}">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(selectedOrderPlant,dropdownOptionOrderPlant)"
                  [indeterminate]="isIndeterminate(selectedOrderPlant,dropdownOptionOrderPlant)"
                  (change)="toggleSelectAll($event,'selectedOrderPlant',dropdownOptionOrderPlant)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="plantFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <mat-option *ngFor="let d of filteredPlant | async" [value]="d" style="font-size: 13px;">
                {{ d.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div id="id2">
          Status
        </div>
        <div>
        
          <mat-form-field appearance="outline" class="fixed-select-ord">
            <mat-select [(ngModel)]="selectedOrderSts" [multiple]="true" [panelWidth]="null" [ngModelOptions]="{standalone: true}">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(selectedOrderSts,dropdownOptionOrderSts)"
                  [indeterminate]="isIndeterminate(selectedOrderSts,dropdownOptionOrderSts)"
                  (change)="toggleSelectAll($event,'selectedOrderSts',dropdownOptionOrderSts)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="orderStsFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <mat-option *ngFor="let d of filteredOrderSts | async" [value]="d" style="font-size: 13px;">
                {{ d.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div id="id3">
          Supplier
        </div>


        <mat-form-field appearance="outline" class="fixed-select-ord">
          <mat-select [(ngModel)]="selectedOrderSupp" [multiple]="true" [panelWidth]="null" [ngModelOptions]="{standalone: true}">
            <div class="search-all-option">
              <mat-checkbox
                [checked]="isAllSelected(selectedOrderSupp,dropdownOptionOrderSupp)"
                [indeterminate]="isIndeterminate(selectedOrderSupp,dropdownOptionOrderSupp)"
                (change)="toggleSelectAll($event,'selectedOrderSupp',dropdownOptionOrderSupp)">
              </mat-checkbox>
              <ngx-mat-select-search [formControl]="orderFilterCtrl" placeholderLabel="Search"
                noEntriesFoundLabel="No options found">
              </ngx-mat-select-search>
            </div>
            <mat-option *ngFor="let d of filteredOrder | async" [value]="d" style="font-size: 13px;">
              {{ d.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>




    </div>


    <!-- ROW 2 -->

    <div class="row">

  <div class="me">

    <div id="id1">
      Region
    </div>

    <div>

      <mat-form-field appearance="outline" class="fixed-select-ord">
  <mat-select [(ngModel)]="selectedOrderRegion" [multiple]="true" [panelWidth]="null" [ngModelOptions]="{standalone: true}">
          <div class="search-all-option">
            <mat-checkbox
              [checked]="isAllSelected(selectedOrderRegion,dropdownOptionOredrRegion)"
              [indeterminate]="isIndeterminate(selectedOrderRegion,dropdownOptionOredrRegion)"
              (change)="toggleSelectAll($event,'selectedOrderRegion',dropdownOptionOredrRegion)">
            </mat-checkbox>
            <ngx-mat-select-search [formControl]="orderRegFilterCtrl" placeholderLabel="Search"
              noEntriesFoundLabel="No options found">
            </ngx-mat-select-search>
          </div>
          <mat-option *ngFor="let d of filteredOrderReg | async" [value]="d" style="font-size: 13px;">
            {{ d.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div id="idTransport">
      Logistics Provider
    </div>
    <div>

      <mat-form-field appearance="outline" class="fixed-select-ord">
  <mat-select [(ngModel)]="selectedOrderTP" [multiple]="true" [panelWidth]="null" [ngModelOptions]="{standalone: true}">
          <div class="search-all-option">
            <mat-checkbox [checked]="isAllSelected(selectedOrderTP,dropdownOptionOredrTP)"
              [indeterminate]="isIndeterminate(selectedOrderTP,dropdownOptionOredrTP)"
              (change)="toggleSelectAll($event,'selectedOrderTP',dropdownOptionOredrTP)">
            </mat-checkbox>
            <ngx-mat-select-search [formControl]="orderTpFilterCtrl" placeholderLabel="Search"
              noEntriesFoundLabel="No options found">
            </ngx-mat-select-search>
          </div>
          <mat-option *ngFor="let d of filteredOrderTp | async" [value]="d" style="font-size: 13px;">
            {{ d.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


  </div>


</div>


<!-- ROW 3 -->



<div class="row">

  <div class="me">

    <div id="id1">
      Start Date<span>*</span>
    </div>

    <div>
      <input type="date" [min]="minDate" [max]="yesterday" onkeydown="return false" (change)="onDateChangedEnd($event)"
        class="  form-control" id="start_Date" name="start_Date" formControlName="start_Date" />
      <p *ngIf="form.controls['start_Date'].errors?.['required']
                && (form.controls['start_Date'].touched || submitted )">
        Start date Required
      </p>
    </div>

    <div id="id4">
      End Date<span>*</span>
    </div>
    <div>
      <input type="date" [min]="newDate" [max]="maxDate" (change)="onDateChangedStart($event)" onkeydown="return false"
        class="  form-control" id="end_Date" name="end_Date" formControlName="end_Date" />
      <p *ngIf="form.controls['end_Date'].errors?.['required']
                && (form.controls['end_Date'].touched || submitted )">
        End date Required
      </p>
      <p
        *ngIf="form.hasError('invalidDate') && (form.controls['end_Date'].touched || form.controls['end_Date'].dirty) && submitted">
        End Date is invalid
      </p>
    </div>



  </div>


</div>


<!-- ROW 4 -->

<div class="row">

  <div class="me">

    <div id="id1">
      <button type="submit" (click)="submitted=true" class="roboto-bold" id="btn">FETCH REPORT</button>
    </div>

  </div>

</div>

</form>


</div>